
export interface IConsumer {
  Address1?: any;
  Address2?: any;
  City?: any;
  Country?: any;
  Email?: any;
  Id: number;
  Name?: any;
  ZipCode?: any;
  PrimaryPhone?: any;
  SecondaryPhone?: any;
  State?: any;
}

export interface IPaymentDetail {
  AccountNumber?: any;
  AccountType?: any;
  CvcCode: number;
  CardNumber: string;
  CheckNumber?: any;
  ExpirationMonth: number;
  ExpirationYear: number;
  MoneyOrderNumber?: any;
  PaymentDay: number;
  PinNumber: number;
  ProfileStatus?: any;
  RoutingNumber?: any;
}

export interface IReferenceIdentity {
  AuthReferenceNumber?: any;
  ProgramCode: string;
  ReferenceNumber: string;
}

export interface IPayment {
  AccountUpdaterEligibilityFlag?: any;
  Amount: number;
  AuthorizationCode: string;
  Consumer: IConsumer;
  EffectiveOn: Date;
  EffectiveThru?: any;
  Id: number;
  IsRecurringMethodRfp: boolean;
  MitTxId?: any;
  OrderDescription: string;
  PartialAuthIndicator?: any;
  PaymentAction: number;
  PaymentDetail: IPaymentDetail;
  PaymentMethodCode: number;
  PaymentMethodName: string;
  PaymentPlanCode?: any;
  PaymentPlanId: number;
  PaymentPlanName?: any;
  RecurringAmount: number;
  ReferenceIdentity: IReferenceIdentity;
  Status: number;
  TotalRecurringAmount?: any;
  TransactionCode: string;
  TransactionCodeId: number;
  TransactionCodeName: string;
  TransactionDateTime: string;
  TransactionTypeCode: number;
  TransactionTypeName: string;
  TransactionUser: string;
  TxRefIdx: string;
  TxRefNum: string;
  UseProfile: boolean;
}

export enum PaymentStatus {
  Pending = 0,
  Success = 1,
  Chargeback = 2,
  Info = 3,
  Void = 4,
  Declined = 5,
  Requested = 6,
  Processed = 7,
  SkippedRetry = 8,
  SentToCatchupQueue = 9,
  Receivedstatus = 10,
  DenialLetter = 11,
  DenialLetterAndSentToCancelQueue = 12,
  DeclinedAllRetries = 13,
}
